import { useState } from 'react';

import { RescheduleAnswerDialogs } from './RescheduleAnswer';

/**
 * The company's two answers to a candidate's request for another time.
 *
 *   const answer = useRescheduleAnswer();
 *   answer.accept(interview, slot?)   // a slot preselects "Use this time"
 *   answer.decline(interview)
 *   {answer.dialogs}
 */
export function useRescheduleAnswer() {
  const [state, setState] = useState(null);
  return {
    accept(interview, slot = null) {
      // Nothing to choose between: go straight to picking a time.
      if (interview.reschedule_request?.any_time) setState({ mode: 'pick', interview });
      else setState({ mode: 'accept', interview, slot });
    },
    decline(interview) {
      setState({ mode: 'decline', interview });
    },
    dialogs: <RescheduleAnswerDialogs state={state} onChange={setState} />,
  };
}
